// @flow
import * as React from "react";

import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import Dropdown from "./Dropdown";

function UserMenu(): React.Node {
  return (
    <Dropdown>
      <li>
        <Link to="/profile" className="UserMenu-item">
          <span className="UserMenu-item__icon">
            <UserOutlined />
          </span>
          <span className="UserMenu-item__label">Profile</span>
        </Link>
      </li>
    </Dropdown>
  );
}

export default UserMenu;
